import React from 'react';
import { format } from 'date-fns';
import { Locale } from 'date-fns/locale';
import { Calendar, ChevronDown } from 'lucide-react';

interface DateDisplayProps {
    isRangeSelection: boolean;
    rangeStart: Date | null;
    rangeEnd: Date | null;
    selectedDate: Date;
    locale: Locale;
    hasProcessedEvents: boolean;
    onClick: () => void;
}

const DateDisplay: React.FC<DateDisplayProps> = ({
    isRangeSelection,
    rangeStart,
    rangeEnd,
    selectedDate,
    locale,
    hasProcessedEvents,
    onClick
}) => {
    let displayContent;

    if (isRangeSelection && rangeStart && rangeEnd) {
        displayContent = (
            <div className="text-sm text-gray-700 dark:text-gray-300 font-medium">
                {format(rangeStart, 'd MMM', { locale })} - {format(rangeEnd, 'd MMM', { locale })}
            </div>
        );
    } else {
        displayContent = (
            <div className="flex flex-col">
                <div className="text-sm text-gray-700 dark:text-gray-300 font-medium">
                    {format(selectedDate, 'd MMMM yyyy', { locale })}
                </div>
                <span className="text-xs text-gray-500 dark:text-gray-400">
                    {format(selectedDate, 'EEEE', { locale })}
                </span>
            </div>
        );
    }

    return (
        <div
            onClick={onClick}
            className="flex items-center space-x-3 px-4 py-3 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-750 transition-colors duration-150 shadow-sm"
            data-has-events={hasProcessedEvents ? 'true' : 'false'}
        >
            <div className="flex-none p-2 bg-blue-50 dark:bg-blue-900 rounded-full">
                <Calendar className="h-5 w-5 text-blue-500 dark:text-blue-400" />
            </div>
            <div className="flex-grow">
                {displayContent}
            </div>
            <div className="flex-none">
                <ChevronDown className="h-4 w-4 text-gray-400 dark:text-gray-500" />
            </div>
        </div>
    );
};

export default React.memo(DateDisplay);